exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.peoples li[data-v-ab60f7e2] {\n  position: relative;\n}\n.selected-chat[data-v-ab60f7e2] {\n  background: #ccc;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
